import { ListItem, Typography } from '@mui/material';

import Icon from '../Icon';

const CheckedListItem = ({ children }) => {
  return (
    <ListItem sx={{ pl: 0, pr: 0, alignItems: 'flex-start' }}>
      <Icon id="check-circle" />
      <Typography variant="oldReleaseCardListItem" sx={{ color: 'text.gray' }}>
        {children}
      </Typography>
    </ListItem>
  );
};

export default CheckedListItem;
